import { deserializeXY } from "../serialization";
import { SolidifiedMob } from "./solidifiedMob";

export class SolidifiedBiter extends SolidifiedMob {
	static key = "SolidifiedBiter";

	static deserialize(data: any): SolidifiedBiter {
		const b = new SolidifiedBiter(deserializeXY(data.xy));
		b.restoreBaseFields(data);
		return b;
	}
}
